<template lang="pug">
  .full-width-wrapper
    div
      //-childコンポーネントのrouter-view
      #child-area
        router-view(ref="myPageChild")
      #headline 
        .m-1 <b>{{$parent.rockyName}}</b> 
        .ml-1 の動画一覧
      .d-flex.flex-wrap.w-100
        .col-12.col-md-4.w-100.mt-3(v-for="item in this.movies")
          .embed-responsive.embed-responsive-16by9
            iframe.embed-responsive-item(:src="getUrlString(item.movieId)")
</template>

<script>
export default {
// データオブジェクト
  data() {
    return {
      //親コンポーネントの値を利用する
      routeList: this.$parent.routeList,
      rockyId: this.$parent.rockyId,
      movies: this.$parent.rockyInfo.movieList,
      isLogin: false,
      //rocky-InfoAPIの戻り値を保持
      rockyMasterData: null,
    }
  },
  created(){
    //直接アクセス等で親画面のデータが空の場合、親画面に遷移する
    if(this.$parent.rockyMasterData == null){
      this.$router.push({ 
        name: 'rockyInfo_:rockyId', 
        params: {
          rockyId: this.$route.params.rockyId,
        }
      })
    }
  },
  mounted(){
    //岩アイコンを表示する(Mapコンポーネント内のメソッド実行)
    this.$parent.$refs.map.showRockMarker(true)
  },
  // メソッド
  methods: {
    // 埋め込み用のYoutubeのURLを生成する
    getUrlString(id){
      return "https://www.youtube.com/embed/" + id + "?controls=0&modestbranding"
    }

  }
}
</script>

<style lang="stylus" scoped>

#headline
  height 40px
  font-size 1.1rem
  background #004170
  color #FFF
  padding-left 0.7rem
  display flex
  align-items center

</style>